import { useLayoutEffect, useState } from 'react'
import { Radio } from 'antd'
import { TextLang } from '../../../types'
import { useIntl } from 'react-intl'
import SelectLang from './SelectLang'
const languageList = require('language-list')()

export default function SelectLangForm({
  textLang,
  setTextLang,
}: {
  textLang: TextLang | null
  setTextLang: any
}) {
  const intl = useIntl()

  // 스티커의 언어를 선택할수 있는 radio 버튼
  const [visible, setVisible] = useState(false)

  useLayoutEffect(() => {
    if (!textLang) {
      setVisible(false)
    } else if (textLang !== 'IMAGE_ONLY') {
      setVisible(true)
    } else {
      setVisible(false)
    }
  }, [textLang])
  const getRadioValue = () => {
    if (!textLang) {
      return -1
    } else if (visible) {
      return visible
    } else {
      return 'IMAGE_ONLY'
    }
  }
  return (
    <div className="select-lang-form-wrapper">
      <div className="select-lang-form-wrapperBasic">
        <div className="select-lang-form-container">
          <Radio.Group
            value={getRadioValue()}
            onChange={(e) => {
              const value = e.target.value
              if (value === 'IMAGE_ONLY') {
                setVisible(false)
                setTextLang('IMAGE_ONLY')
              } else {
                setVisible(e.target.value)
              }
            }}
          >
            <Radio value={'IMAGE_ONLY'} style={{ marginLeft: 16 }}>
              {intl.formatMessage({
                id: 'PackageInfo.package.language.onlyImage',
              })}
            </Radio>

            <Radio value={true} style={{ marginLeft: 75 }}>
              {intl.formatMessage({
                id: 'PackageInfo.package.language.withText',
              })}
            </Radio>
          </Radio.Group>
        </div>
        <div data-cy="basic-lang-selector">
          {/* visible 이 ture 면 textlang 은 null 이 될수 없음 */}
          {visible && (
            <SelectLang
              textLang={textLang as TextLang}
              setTextLang={setTextLang}
            />
          )}
        </div>
      </div>
    </div>
  )
}
